import React from "react";
import { Link } from "react-router-dom";

import {
	IconFeatherHome,
	IconFeatherUser,
	IconMapPetStore,
	IconMaterialChatBubbleOutline,
	QrCode,
} from "../../Icons/img";

import { Container } from "./styles";

export default function BarNavigation() {
	return (
		<Container id='aside'>
			<nav>
				<ul>
					<li>
						<Link to={`${process.env.PUBLIC_URL}/home/consumer`}>
							<IconFeatherHome />
						</Link>
					</li>
					<li>
						<Link to={`${process.env.PUBLIC_URL}/stores`}>
							<IconMapPetStore />
						</Link>
					</li>
					<li>
						<Link to={`${process.env.PUBLIC_URL}/cupons`}>
							<QrCode width={24} heigth={24} />
						</Link>
					</li>
					<li>
						<Link to={`${process.env.PUBLIC_URL}/notificacoes`}>
							<IconMaterialChatBubbleOutline />
						</Link>
					</li>
					<li>
						<Link to={`${process.env.PUBLIC_URL}/profile`}>
							<IconFeatherUser />
						</Link>
					</li>
				</ul>
				<img
					className='logo-labyes'
					src={require("@/assets/img/logo-labyes.png").default}
					alt='logo labyes'
				/>
			</nav>
		</Container>
	);
}
